import React, { useRef, useState } from 'react'
import { cx, css } from '@emotion/css'
import './style.sass'
import writingService from '@/app-domains/messages/draft/writing.service'
import useRenderEvent from '@/core/hooks/useRenderEvent'

export const EditorButton = React.forwardRef(
  function Button (
    {
      active,
      ...props
    },
    ref
  ) {
    return (
      <div
          {...props}
          size="small"
          ref={ref}
          style={
            {
              display: 'inline-block',
              background: 'white',
            }
          }
          className={active ? 'toolbar-button active' : 'toolbar-button inactive'}
        />
    )
  }
)

export const AddAttachmentButton = React.forwardRef(
  function AddAttachmentButton (
    {
      // eslint-disable-next-line
      active,
      ...props
    },
  ) {
    const isReply = props.isReply
    const inputRef = useRef(null)
    
    // eslint-disable-next-line
    const [isPreOpenDone, setIsPreOpenDone] = useState(false)
    
    async function onChangeAttachment (event) {
      event.preventDefault()
      event.stopPropagation()

      const file = event.target.files && event.target.files[0]
      if (!file) {
        return
      }
      for (const file of event.target.files) {
        const reader = new window.FileReader()
        reader.readAsDataURL(file)
        reader.onload = async () => {
          await writingService.uploadAttachment(file, reader.result)
        }
      }
    }

    if (!isReply) {
      useRenderEvent(['DRAFT_SECTION:OPEN_ATTACHMENT'], () => {
        inputRef?.current?.click()
        setIsPreOpenDone(true)
      })
    }
    return (
      <label
        {...props}
        style={{
          display: 'inline',
          background: 'rgba(0,0,0,0)',
          color: 'rgba(0,0,0, 0.4)',
          boxShadow: '0',
          WebkitBoxShadow: '0',
          padding: '0',
          '&:hover': {
            cursor: 'pointer'
          }
        }}
        ref={inputRef}
        component="label"
      >
        <input
          type="file"
          hidden
          onChange={onChangeAttachment}
          multiple
        />
        {props.children}
      </label>
    )
  }
)

export const SendButton = React.forwardRef(
  function SendButton (
    {
      // eslint-disable-next-line
      active,
      ...props
    },
  ) {
    return (
      <Button
      {...props}
      variant="contained"
      style={{
        background: '#1976d2',
        color: 'white',
        boxShadow: '0',
        WebkitBoxShadow: '0',
        opacity: props.isActive ? '1' : '0.3'
      }}
      disabled={!props.isActive}
    >
        Send
      </Button>
      
    )
  }
)

export const EditorValue = React.forwardRef(
  function EditorValue
  (
    {
      className,
      value,
      ...props
    },
    ref
  ) {
    const textLines = value.document.nodes
      .map(node => node.text)
      .toArray()
      .join('\n')

    return (
      <div
        ref={ref}
        {...props}
        className={cx(
          className,
          css`
            margin: 30px -20px 0;
          `
        )}
      >
        <div>
          Slate's value as text
        </div>
        <div
        >
          {textLines}
        </div>
      </div>
    )
  }
)

export const Menu = React.forwardRef(
  function Menu (
    // eslint-disable-next-line
    { className, ...props },
    // eslint-disable-next-line
    ref
  ) {
    return (
      <div style={{ width: '100%', padding: '10px' }} {...props}>

      </div>
    )
  }
)

export const Toolbar = React.forwardRef(
  function Toolbar (
    { ...props },
    ref
  ) {
    return (
      <Menu
      {...props}
      ref={ref}
      className='toolbar'
    />
    )
  }
)
